import React, { Component } from 'react';
import { toast, ToastContainer, MDBSelect, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';
import TopSeller from './ComponentFragments/TopSeller';
import SelectSearch from 'react-select-search';

class MyOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData: [],
            filteredData: [],
            selectedOption: 1,
            filterOptions: [],
            trackingModalOpen: false,
            scans: [],
            currentLabelId: ''
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.searchList = this.searchList.bind(this);
        this.showDocument = this.showDocument.bind(this);
        this.cancelOrder = this.cancelOrder.bind(this);
        this.showDispatch = this.showDispatch.bind(this);
        this.handleFilterSelectChange = this.handleFilterSelectChange.bind(this);
        this.getTrackingInfo = this.getTrackingInfo.bind(this);
    }

    async getTrackingInfo(labelId) {
        this.props.loaderOn();
        let response = await this.dl.Get("/demonstrator/GetTrackingInformation?labelId=" + labelId);
        this.setState({
            scans: response.data,
            currentLabelId: labelId,
            trackingModalOpen: true
        })
        this.props.loaderOff();
    }

    handleFilterSelectChange(selected) {
        let arr = [];
        switch (selected[0]) {
            case 1:
                arr = this.state.orderData
                break;
            case 2:
                arr = this.state.orderData.filter((item) => (item.SFInvoiceId != -1) && (item.EcommerceInvoice == 0));
                break;
            case 3:
                arr = this.state.orderData.filter((item) => (item.EcommerceInvoice == 1));
                break;
            case 4:
                arr = this.state.orderData.filter((item) => (item.SFInvoiceId == -1));
                break;
            
        }
        this.setState({
            selectedOption: selected[0],
            filteredData: arr
        });
    }

    showDispatch(item) {
        if (item.DispatchCount == 1) {
            this.props.history.push({
                pathname: '/salesforce/dispatchnote',
                search: 'invoiceid=' + item.SFInvoiceId + '&noteid=' + item.SFInvoiceDispatchNoteId
            })
        } else {
            this.props.history.push({
                pathname: '/salesforce/dispatchlist',
                search: 'invoiceid=' + item.SFInvoiceId
            })
        }
    }

    async cancelOrder(orderId) {
        this.props.loaderOn();
        let response = await this.dl.Get("/common/cancelorder?orderId=" + orderId);
        if (!response.errorOccurred) {
            //remove from array
            let orderData = this.state.orderData;
            orderData.splice(orderData.findIndex((item) => item.SFOrderId === orderId), 1);
            this.setState({
                orderData
            })
        }
        this.props.loaderOff();
    }

    showDocument(item) {
        //const { history } = this.props;
        this.props.history.push({
            pathname: '/salesforce/invoiceorder',
            search: 'id=' + (item.Released === 1 ? item.SFInvoiceId : item.SFOrderId) + '&released=' + (item.Released === 1 ? true : false),
            state: { documentType: item.Released === 1 ? "INVOICE" : "ORDER", documentNo: item.Released === 1 ? item.SFInvoiceId : item.SFOrderId }
        })
    }

    searchList(phrase) {
        let arr = this.state.orderData.filter((item) => (item.SFOrderId.toString().includes(phrase.toUpperCase())) || (item.SFInvoiceId.toString().includes(phrase.toUpperCase())));

        switch (this.state.selectedOption) {
            case 1:
                break;
            case 2:
                arr = arr.filter((item) => (item.SFInvoiceId != -1) && (item.EcommerceInvoice == 0));
                break;
            case 3:
                arr = arr.filter((item) => (item.EcommerceInvoice == 1));
                break;
            case 4:
                arr = arr.filter((item) => (item.SFInvoiceId == -1));
                break;

        }

        this.setState({ filteredData: arr });
    }

    async componentWillMount() {
        this.props.loaderOn();
        let response = await this.dl.Get("/common/getmyorders")
        
        let filterData = [];
        filterData.push({checked: true, value: 1, text: 'All' });
        filterData.push({checked: false, value: 2, text: 'Traditional Invoices' });
        filterData.push({ checked: false, value: 3, text: 'Ecommerce Invoices' });
        filterData.push({ checked: false, value: 4, text: 'Uncleared Orders' });

        this.setState({
            orderData: response.data,
            filteredData: response.data,
            filterOptions: filterData
        })
        this.props.loaderOff();
    }

    



    render() {
        const titleStyle = {
            fontSize: "16px",
            fontWeight: "bold",
            color: "#333",
        };

        const subTextStyle = {
            fontSize: "14px",
            color: "#666",
        };

        const cardStyle = {
            borderRadius: "12px",
            background: "#ffffff",
            padding: "16px",
            marginTop: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            transition: "transform 0.2s ease",
        };

        const buttonStyle = {
            display: "inline-block",
            backgroundColor: "#007BFF",
            color: "white",
            padding: "8px 12px",
            borderRadius: "25px",
            fontSize: "12",
            cursor: "pointer",
            textAlign: "center",
            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
            userSelect: "none",
        };
        return (
            <div>
                <Header headerText="Orders"
                    placeholderText="Search Orders / Invoices"
                    searchList={this.searchList}
                />
                <MDBRow className="mt-3">
                    <MDBCol sm="12">
                        <MDBSelect label="Filter By"
                            options={this.state.filterOptions}
                            selected="Filter"
                            getValue={this.handleFilterSelectChange}
                            required
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    {
                        this.state.filteredData.map((item) => {
                            return (
                                <MDBCol xl="3" lg="6" md="6" sm="12" className="mb-r" >
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>
                                            <MDBIcon icon="file-invoice" />&nbsp;{item.Released === 1 ? "Invoice" : "Order"}
                                            <MDBBadge color="light" hidden={item.OutStanding < 1} className="float-right">Outstanding: {item.OutStanding}</MDBBadge>
                                        </MDBCardTitle>
                                        <MDBCardTitle style={{ fontSize: "14px" }}>
                                            &nbsp;<MDBIcon icon="hashtag" />&nbsp;Number:&nbsp;{item.Released === 1 ? item.SFInvoiceId : item.SFOrderId}
                                            {item.HasLabel ? <div style={ buttonStyle} onClick={() => this.getTrackingInfo(item.LabelId)} className="float-right">Track</div> : <div></div>}
                                        </MDBCardTitle>
                                        <MDBCardTitle hidden={item.EcommerceInvoice ? false : true} style={{ fontSize: "14px" }}>
                                            <span style={{color: "green"}}><MDBIcon icon="shopping-cart" /> Ecommerce Invoice</span>
                                            </MDBCardTitle>
                                        <hr className="hr_grey" />
                                        <MDBCardText>
                                            <MDBIcon icon="coins" />&nbsp;Recognition:&nbsp;<strong>{this.formatter.formatCurrency(item.Recognition)}</strong><br />
                                            <MDBIcon far icon="calendar-alt" />&nbsp;Week:&nbsp;{item.WeekId}<br />
                                            <MDBIcon icon={item.Dispatched == 1 ? "check-circle" : "times-circle"} />&nbsp;Dispatched:&nbsp;{item.Dispatched == 1 ? item.OutStanding > 0 ? "Partial" : "All" : "No"}
                                            <p>{item.Released == 1 ? <span><MDBIcon icon="hashtag" />&nbsp;Order No:&nbsp;{item.SFOrderId == -1 ? "" : item.SFOrderId} </span> 
                                                : item.Cancelled == 1 ? <span style={{color:'red'}}><MDBIcon icon="times-circle" /> Order Cancelled</span> : <span className="cartRemoveItem" onClick={() => this.cancelOrder(item.SFOrderId)}><MDBIcon far icon="trash-alt" /> Cancel Order</span>}</p>
                                        </MDBCardText>
                                        <hr className="hr_grey" />
                                        <div className="flex-row text-center" >
                                            <MDBBtn rounded color="purple" size="sm" onClick={() => this.showDocument(item)}>View&nbsp;{item.Released === 1 ? "Invoice" : "Order"}</MDBBtn>
                                            <MDBBtn hidden={item.Dispatched === 1 ? false : true} rounded color="pink" size="sm" onClick={() => this.showDispatch(item)}>Dispatch Info</MDBBtn>
                                            
                                        </div>
                                    </MDBCard>
                                </MDBCol>
                            )
                        })
                    }
                </MDBRow>
                <MDBModal isOpen={this.state.trackingModalOpen} toggle={this.state.trackingModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "blue" }}><MDBIcon fas icon="info" /></span>&nbsp;Tracking Information: {this.state.currentLabelId}</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.scans && this.state.scans.length > 0 ? (
                            this.state.scans.map((scan, index) => (
                                <div
                                    key={index}
                                    style={cardStyle}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                >
                                    <div style={titleStyle}>{scan.status}</div>
                                    <div style={subTextStyle}>{scan.statusDescription}</div>
                                    <div style={subTextStyle}>
                                        {scan.realDateTime}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div style={{ textAlign: "center", color: "#888" }}>
                                No tracking info available. Please check back later.
                            </div>
                        )}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ trackingModalOpen: false })}>Close</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>
        )
    }
}

export default MyOrders;